import React, { FC, Fragment, useState } from "react";
import styled from "styled-components";
import ImageZoom from "../../components/ImageZoom";

const CommentImage: FC<{ image: any }> = ({ image }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Fragment>
      <ImageContainer
        title="Click to preview image"
        onClick={() => setOpen(true)}
      >
        <Image src={image?.uri?.showUri} />
      </ImageContainer>
      {open && (
        <ImageZoom
          images={[image]}
          index={0}
          handleClose={() => setOpen(false)}
        />
      )}
    </Fragment>
  );
};

export default CommentImage;

const ImageContainer = styled.div`
  cursor: pointer;
`;
const Image = styled.img`
  width: 100%;
  max-height: 480px;
  object-fit: cover;
  object-position: center;
`;
